export function dateWithoutTimeKey(date: Date) {
  const wrappedDate = new Date(date);
  return `${wrappedDate.getFullYear()}_${wrappedDate.getMonth()}_${wrappedDate.getDate()}`;
}
